import {useState} from 'react';
import {FiInbox} from "react-icons/fi";
import {Link, useLocation} from 'react-router-dom';
import './login.css';
import Logo from '../../components/Logo';
import api from '../../config.js';
import {toast} from "react-toastify";

function SignIn() {
    const {search} = useLocation();
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const searchParams = () => new URLSearchParams(search);

    function handleSubmit(e) {
        e.preventDefault();
        if (password !== passwordConfirm) {
            toast.error('Senhas são diferentes')
            return;
        }
        const token = searchParams().get('token');
        if (token === null) {
            toast.error('Token não enviado')
            return;
        }

        api
            .post('/api/password/reset', {
                    password: password,
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    }
                }
            )
            .then(() => {
                toast.success('Senha alterado com sucesso');
                setPassword('');
                setPasswordConfirm('');
            })
            .catch(() => {
                toast.error('Erro ao alterar senha')
            })
    }

    return (
        <div className="content-page">
            <div className="content-view">
                <div className="logo-view">
                    <Logo/>
                </div>
            </div>
            <div className="content-login">
                <div className="login">
                    <form className="formLogin" onSubmit={handleSubmit}>
                        <h1><FiInbox color="#FFF" size={50}/><label className="label-title">WMS Gruppe</label></h1>
                        <input type="password" placeholder="Senha" value={password}
                               onChange={(e) => setPassword(e.target.value)}/>
                        <input type="password" placeholder="Repetir Senha" value={passwordConfirm}
                               onChange={(e) => setPasswordConfirm(e.target.value)}/>
                        <button className="loginButton" type="submit">Alterar senha</button>
                        <div className="content-recuperacao">
                            <Link to={'/'}>Login</Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default SignIn;
